import { render, staticRenderFns } from "./CampaignConfirm.vue?vue&type=template&id=4949e047&scoped=true&"
import script from "./CampaignConfirm.vue?vue&type=script&lang=js&"
export * from "./CampaignConfirm.vue?vue&type=script&lang=js&"
import style0 from "./CampaignConfirm.vue?vue&type=style&index=0&id=4949e047&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4949e047",
  null
  
)

export default component.exports